/*
 * @Author: 张印 hbzyin@163.com
 * @FilePath: /mall-fe/src/api/std.ts
 * @Description: 商城首页配置相关服务API
 *
 */
import { CUSTOM_PAGE_TAG, FloorType } from 'libs/enums';
import { fetch } from 'libs/fetch';
// TODO error to 500
/**
 * @description: 获取站点配置信息
 * @param {Object} json
 * @return {*} res 配置信息
 */
export async function getSiteConfig(options?: FetchOptions): Promise<Partial<SiteConfig>> {
  const res = await fetch('/api/basic/v1/tenant/customization/config', options);

  if (res.code === 200) {
    const { data } = res;
    if (data?.global?.platformMainColor) {
      data.global.platformMainColor = '#' + data.global.platformMainColor;
    }
    return data || {};
  } else {
    return {};
  }
}

// 老的api，暂时 bak
/**
 * @description: 验证会员接口 老接口兼容
 * @param {string | number} supplierSysNo 用户系统编号
 * @return {boolean} res 是否会员
 */
export async function getMemberOld(supplierSysNo: string | number, options?: FetchOptions) {
  const res = await fetch<GetMemberTypeOld>(
    `/api/supplier/v1/supplier/basis/member/get/${supplierSysNo}`,
    {
      ...options,
    },
  );
  return res;
}
/**
 * @description: 验证会员接口
 * @param {string | number} supplierSysNo 用户系统编号
 * @return {boolean} res 是否会员
 */
export async function getMember(supplierSysNo: string | number, options?: FetchOptions) {
  const res = await fetch<GetMemberType>(
    `/api/supplier/v1/supplier/basis/member/supplierMemberInfo/${supplierSysNo}`,
    {
      ...options,
    },
  );
  return res;
}

// 判断本级是否已认证(采购商)
/**
 * @description: 判断本级是否已认证(采购商)
 * @param {string | number} supplierSysNo 用户系统编号
 * @param {FetchOptions} options 请求配置信息
 * @return {boolean} res 是否已认证
 */
export async function getPurchaserInfo(supplierSysNo, options?: FetchOptions) {
  const res = await fetch<any>(
    `/api/supplier/v2/basis/supplier/get?supplierSysNo=${supplierSysNo}`,
    {
      ...options,
    },
  );
  return res;
}

//  接口无引用，待验证后删除
// export async function getGoodsPricePermission(options?: FetchOptions) {
//   return fetch<any>('/api/mall/v1/mall/getGoodsPricePermission', options);
// }

/**
 * @description: 获取首页楼层配置
 * @param {FloorType} type 楼层类型
 * @param {FetchOptions} options 请求配置信息
 * @return {boolean} res 楼层配置信息
 */
export async function getFloor(type: FloorType, options?: FetchOptions) {
  return fetch<any>(`/api/mall/v1/mall/getFloor/${type}`, options);
}

export async function getFloorV2(type: FloorType, options?: FetchOptions) {
  return fetch<any>(`/api/mall/v1/mall/getFloorV2/${type}`, options);
}
/**
 * @description: 获取首页分区配置
 * @param {string} code 楼层类型
 * @param {FetchOptions} options 请求头配置信息
 * @return {boolean} res 分区配置信息
 */
export async function getSectorData(code: string, options?: FetchOptions) {
  return fetch<any>(`/api/mall/v1/zjzq/getPageConfig/${code}`, options);
}
/**
 * @description: 获取首页推荐店铺信息
 * @param {FloorType} data 类型
 * @param {FetchOptions} options 请求头配置信息
 * @return {boolean} res 推荐店铺配置信息
 */
export async function getRecommendShop(data, options?: FetchOptions) {
  return fetch<any>(`/api/mall/v1/shop/queryRecommendShopList`, {
    method: 'POST',
    ...options,
    json: data,
  });
}

/**
 * @description: 获取首自定义页面标签
 * @param {CUSTOM_PAGE_TAG} tag 类型
 * @param {FetchOptions} options 请求头配置信息
 * @return {boolean} res 页面自定义信息
 */
export async function getCustomPageByTag(tag: CUSTOM_PAGE_TAG, options?: FetchOptions) {
  const res = await fetch<any>(`/api/mall/v1/customPage/purchaser/getByTag/${tag}`, {
    ...options,
    method: 'POST',
  });
  return res;
}

export function getProcureEnumsData(options?: FetchOptions) {
  return fetch('/api/tender/v1/commonDictionary/enum', {
    ...options,
    method: 'GET',
  });
}
